import { features, carouselItems, comments } from '@/mocks/home';

export default function Features() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">为什么选择麻花影视</h2>
          <p className="text-foreground-600 max-w-[600px] mx-auto">聚合四虎影视、影视飓风、番茄影视等特色频道，给你不一样的观影体验</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((item, i) => (
            <div key={i} className="group bg-background-50 rounded-xl p-6 md:p-8 transition-all duration-200 hover:bg-background-50">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100/60 text-primary-500 mb-5 group-hover:bg-primary-500 group-hover:text-white transition-all duration-200">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function Carousel() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">焦点专题</h2>
          <p className="text-foreground-600 max-w-[600px] mx-auto">精选各频道最值得关注的专题内容，一站尽览热门好片</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {carouselItems.map((item, i) => (
            <div key={i} className="group bg-background-100 rounded-2xl overflow-hidden transition-all duration-300 hover:bg-background-100">
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <span className="absolute top-4 left-4 bg-accent-500 text-white text-xs px-3 py-1 rounded-full font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function Comments() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">影迷热评</h2>
          <p className="text-foreground-600 max-w-[600px] mx-auto">来自真实影迷的使用反馈，听听他们怎么说</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {comments.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-6 md:p-7">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(item.rating)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-5">{item.content}</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.time}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}